import { cn } from '@listening/utils/react-helpers';
import { Button } from '@listening/frontend/components/radix/button';
import { Input } from '@listening/frontend/components/radix/input';
import { Label } from '@listening/frontend/components/radix/label';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@listening/frontend/components/radix/select';

export function ContactIsland() {
  return (
    <form className='w-full space-y-8' id='book-a-demo'>
      <div className='grid grid-cols-1 gap-6 xl:grid-cols-2'>
        <div className='space-y-2'>
          <Label className='mb-2 text-[1rem] leading-[1.35] font-medium text-neutral-945'>
            First name
          </Label>
          <Input
            autoComplete='given-name'
            className='h-13 rounded-lg border-steel-120 bg-mist-220/50 p-4 text-[1rem] leading-tight font-medium'
            name='firstName'
            placeholder='First name'
          />
        </div>

        <div className='space-y-2'>
          <Label className='mb-2 text-[1rem] leading-[1.35] font-medium text-neutral-945'>
            Last name
          </Label>
          <Input
            autoComplete='family-name'
            className='h-13 rounded-lg border-steel-120 bg-mist-220/50 p-4 text-[1rem] leading-tight font-medium'
            name='lastName'
            placeholder='Last name'
          />
        </div>
      </div>
      <div className='space-y-2'>
        <Label className='mb-2 text-[1rem] leading-[1.35] font-medium text-neutral-945'>
          Email
        </Label>
        <Input
          autoComplete='email'
          className='h-13 rounded-lg border-steel-120 bg-mist-220/50 p-4 text-[1rem] leading-tight font-medium'
          name='email'
          placeholder='name@institution.edu'
          type='email'
        />
      </div>

      <div className='space-y-2'>
        <Label className='mb-2 text-[1rem] leading-[1.35] font-medium text-neutral-945'>
          How many students do you have at your school?
        </Label>
        <Select name='studentsAtSchool'>
          <SelectTrigger
            className={cn(
              'h-13 w-full rounded-lg border-steel-120 bg-mist-220/50 p-4 text-[1rem] leading-tight font-medium data-placeholder:text-muted-foreground/50',
              '[&>span]:currentColor',
            )}
          >
            <SelectValue placeholder='Select number of students' />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              <SelectLabel>Students:</SelectLabel>
              <SelectItem value='1-500'>1-500</SelectItem>
              <SelectItem value='500-2000'>500-2000</SelectItem>
              <SelectItem value='2000-5000'>2000-5000</SelectItem>
              <SelectItem value='+5000'>+5000</SelectItem>
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>

      <Button
        className='inline-flex h-auto items-center justify-center gap-2 self-center rounded-full border-b-4 border-cloud-375 bg-primary px-8 py-3 text-lg font-[500] whitespace-nowrap text-primary-foreground ring-offset-background transition-colors hover:bg-primary/90 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50'
        type='submit'
      >
        Book a Demo
      </Button>
    </form>
  );
}
